module.exports = __webpack_public_path__ + "static/img/Enschede.9414a6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Enschede.jpg
// module id = yI6c
// module chunks = 1